import invokeApi from './../util/apiclient'
export const GET_TEAM = 'GET_TEAM'
export const SET_TEAM = 'SET_TEAM'
export const NEW_TEAM = 'NEW_TEAM'
export const SET_USER = 'SET_USER'

export function getTeam (teamId) {
    return (dispatch) => {
        return invokeApi('GET', '/teams/{teamId}/', {teamId})
            .then((response) => {
                dispatch({ type: GET_TEAM + '/SUCCESS', result: response.data })
            }).catch((result) => {
                dispatch({ type: GET_TEAM + '/FAILED' })                
            })
    }
}

export function setTeam (teamId, name, leaderId) {
  return (dispatch) => {
      return invokeApi('PUT', '/teams/{teamId}/', { teamId }, { name, leaderId })
          .then((response) => {
              dispatch({ type: SET_TEAM + '/SUCCESS', result: response.data })
          }).catch((result) => {
              dispatch({ type: SET_TEAM + '/FAILED' })                
          })
  }
}

export function newTeam (name, officialStage, chargeId, chargeEmail) {
    return (dispatch) => {
        return invokeApi('POST', '/teams/', {}, { name, officialStage, chargeId, chargeEmail })
            .then((response) => {
                dispatch({ type: NEW_TEAM + '/SUCCESS', result: response.data })
            }).catch((result) => {
                dispatch({ type: NEW_TEAM + '/FAILED' })
                throw result
            })
    }
}